import { useState, useCallback, useEffect, useMemo } from 'react'
import { twinFetchPostJSON } from '../../../utils/globals/data'
import { getEmployeeParams } from '../../../utils/reducers/getters'
import { changeEmployeeParams } from '../../../utils/reducers/reduxDispatch'
import { filterUserWidgetsByAvaliableWidgets, filterWidgetsByPermissions } from '../../Dashboard/useDashboardWidgets'
import { DashboardWidgetAndFamiliesExtraComplete, UserWidget, WidgetDictionary } from '../../Dashboard/useDashboardWidgets/types'

export interface UseDashboardWidgetsLogicProps {
    name: string
    defaultWidgets: string
    allWidgets: WidgetDictionary
}

export const useSCDashboardWidgets = ({ name, defaultWidgets, allWidgets }: UseDashboardWidgetsLogicProps): DashboardWidgetAndFamiliesExtraComplete => {
    const [userDashboardWidgets, setUserDashboardWidgets] = useState<UserWidget[]>([])

    const avaliableDashboardWidgets: WidgetDictionary = useMemo(() => {
        return filterWidgetsByPermissions(allWidgets)
    }, [allWidgets])

    const getUserWidgets = useCallback(async () => {
        const dashboard_distribution = getEmployeeParams()?.[name]
        const params = dashboard_distribution ? JSON.parse(dashboard_distribution) : JSON.parse(defaultWidgets)
        setUserDashboardWidgets(filterUserWidgetsByAvaliableWidgets(avaliableDashboardWidgets, params))
    }, [setUserDashboardWidgets, defaultWidgets, name, avaliableDashboardWidgets])

    const saveUserWidgets = useCallback(async () => {
        const myName = name
        const myValue = JSON.stringify(userDashboardWidgets)
        await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: myName, value: myValue })
        changeEmployeeParams({ [myName]: myValue })
    }, [userDashboardWidgets, name])

    useEffect(() => {
        getUserWidgets()
    }, [getUserWidgets])

    return { userDashboardWidgets, setUserDashboardWidgets, getUserWidgets, saveUserWidgets, avaliableDashboardWidgets }
}

export default useSCDashboardWidgets